"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.piggy = void 0;
/* eslint-disable max-len */

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var piggy = function piggy(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  var classes = (0, classnames_1["default"])('helix-icon', 'piggy-outlined', className);
  return react_1["default"].createElement("svg", Object.assign({
    className: classes,
    width: '20',
    height: '20',
    viewBox: '0 0 20 20',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    "aria-hidden": 'true'
  }, rest), react_1["default"].createElement("path", {
    d: 'M6 9C5.44772 9 5 8.55228 5 8C5 7.44772 5.44772 7 6 7C6.55228 7 7 7.44772 7 8C7 8.55228 6.55228 9 6 9Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M4.4265 2.14012C4.594 1.94136 4.85247 1.84349 5.10962 1.88148C5.98205 2.01036 6.67225 2.35568 7.20148 2.77505C8.22567 2.42219 9.35173 2.25 10.5 2.25C13.6604 2.25 16.2646 3.69127 17.6555 5.82912C17.9671 5.52857 18.2499 4.99194 18.2499 4H19.7499C19.7499 5.56754 19.1873 6.60768 18.3433 7.20057C18.6084 7.92382 18.75 8.69718 18.75 9.49997C18.75 12.1513 17.2234 14.5169 14.75 15.7787V17C14.75 17.4142 14.4142 17.75 14 17.75H12C11.5858 17.75 11.25 17.4142 11.25 17V16.7236C11.0041 16.7411 10.754 16.75 10.5 16.75L9.75 16.75V17C9.75 17.4142 9.41421 17.75 9 17.75H7C6.58579 17.75 6.25 17.4142 6.25 17V15.8682C4.93485 15.266 3.99402 14.4567 3.36694 13.7691C3.01671 13.385 2.76273 13.0372 2.59402 12.781L2.57374 12.75H2C1.58579 12.75 1.25 12.4142 1.25 12V7.99997C1.25 7.58576 1.58579 7.24997 2 7.24997H2.88468C3.19953 5.98139 3.85088 4.96501 4.72414 4.18864L4.28738 2.8572C4.20635 2.61022 4.25899 2.33889 4.4265 2.14012ZM10.5 3.75C7.19731 3.75 4.66438 5.28996 4.24172 8.1111C4.18671 8.4783 3.8713 8.74997 3.5 8.74997H2.75V11.25H3C3.2831 11.25 3.54199 11.4094 3.6695 11.662L3.67031 11.6636L3.67495 11.6723C3.68064 11.683 3.69066 11.7014 3.70516 11.7268C3.73418 11.7776 3.78102 11.8561 3.84681 11.956C3.97857 12.1561 4.18515 12.4402 4.47529 12.7584C5.05564 13.3948 5.96386 14.161 7.27334 14.6735C7.56083 14.786 7.75 15.0632 7.75 15.3719V16.25H8.25V16C8.25 15.5858 8.58578 15.25 8.99999 15.25L10.5 15.25C10.9823 15.25 11.4434 15.2128 11.8815 15.1427C12.0984 15.108 12.3196 15.1701 12.4867 15.3126C12.6538 15.4551 12.75 15.6637 12.75 15.8833V16.25H13.25V15.304C13.25 15.0058 13.4266 14.736 13.6999 14.6167C15.9384 13.6394 17.25 11.6614 17.25 9.49997C17.25 6.48824 14.5822 3.75 10.5 3.75Z',
    fill: '#4B5563'
  }));
};

exports.piggy = piggy;